import React from 'react';
import '../App.css';
import doctorImage from '../assets/images/doctor.jpg';
import { FaUserMd } from 'react-icons/fa';

const AboutDoctor = () => {
  return (
    <section id="about-section" className="enhanced-doctor-section">
      <div className="doctor-container">
        <div className="doctor-left">
          <img src={doctorImage} alt="Dr. Srishti Dangwal" className="doctor-image" />
          <h2>Dr. Srishti Dangwal</h2>
          <h4>BDS, MYS, MBA</h4>
          <h4>Oral Implantologist</h4>
          <div className="highlight-card">
            <FaUserMd className="icon" /> 7+ Years of Expertise
          </div>
        </div>

        <div className="doctor-right">
          <h3 className="section-title">About Our Clinic</h3>
          <p>
            Dr Srishti's Dentistry & Wellness Clinic offers best dental service with latest dental equipments and digital technology. Also offers ways to improve lifestyle, how to correct systemic disorders through yoga and holistic approach and live a healthy full filling life. As the founder of <strong>Dr. Srishti's Dentistry and Wellness Clinic</strong> known for her compassionate care and over a decade of clinical expertise, she blends cutting-edge dental technology with a warm, patient-focused philosophy  ensuring each smile is treated with precision and empathy.
          </p>
          <p>
            Specializing in <strong>preventive dentistry</strong>, <strong>restorative treatments</strong>, and <strong>cosmetic smile makeovers</strong>, Dr. Srishti provides <strong>pain-free dental care</strong> focused on both oral health and overall wellness. From check-ups to smile transformations, every patient receives personalized and calming care.
          </p>
          <blockquote className="doctor-quote">
            "We care for more than just your teeth — we care for your complete smile and well-being."
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default AboutDoctor;
